export default "__VITE_ASSET__Nuw9z8YP__"